"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var monsters = {
  id: "monsters",
  title: {
    en: "Monster",
    de: "Monster"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Monster"), /*#__PURE__*/_react.default.createElement("p", null, "There are three different types of monsters in Idios, animal type monster, human like monster, and monster."), /*#__PURE__*/_react.default.createElement("p", null, "From animal type monster you can get various materials or items, but can't get any weapons or armors. They're intelligence is lower than human like monster, therefore you can hunt them much easier."), /*#__PURE__*/_react.default.createElement("p", null, "Human like monsters have higher intellegnce and much more difficult ot hunt, but you can get various weapons, and armors."), /*#__PURE__*/_react.default.createElement("p", null, "Special monsters have their own camp, and they have group leader."), /*#__PURE__*/_react.default.createElement("p", null, "in some special cases monster can react with other monsters, and they can form alliance, so be careful. Some special classes have special skills that can stop the alliance."))
  }
};
var _default = monsters;
exports.default = _default;